/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {InfoIcon} from '@ion/dls/src/icons/InfoIcon';
import {DLSTheme} from '@ion/dls/src/types/types';

const useStyles = makeStyles((theme: DLSTheme) => ({
  infoIcon : {
    margin         : '0 6px',
    display        : 'flex',
    alignItems     : 'center',
    justifyContent : 'center',
    cursor         : 'default'
  },
  status : {
    fontStyle : 'italic'
  },
  field : {
    fontWeight : 500
  }
}));

/**
 * The `JobSearchEngineTooltip` component displays the Tooltip and associated
 * informational messaging in the context of the Job Search Engine which includes a
 * list of properties that can be searched.
 */
export const JobSearchEngineTooltip = () => {
  const classes = useStyles();
  const {fields, statuses, search, exact, partial} = translate('common:jobSearch.messages', {returnObjects: true});
  const exactMsg = <span>{'For '}<span className={classes.field}>{'Status, '}</span>{exact}</span>;
  const getField = (field) => (
    <span className={classes.field}>{field}</span>
  );
  const getStatus = (status) => (
    <span className={classes.status}>{status}</span>
  );

  return (
    <Tooltip title={
      <>
        <p>
          <span>{search}</span>
          {Object.values(fields)?.map((field, index, array) => (
            <span key={index}>
              {getField(field)}
              {index === array.length - 2 ? ' and ' : index < array.length - 2 ? ', ' : ''}
            </span>
          ))}<br/></p>
        <p>{exactMsg}
          <span>
            &nbsp;
            {Object.values(statuses)?.map((status, index, array) => (
              <span key={index}>
                {getStatus(status)}
                {index === array.length - 2 ? ' and ' : index < array.length - 2 ? ', ' : ''}
              </span>
            ))}
          </span>
        </p>
        <p>{partial}</p>
      </>
    }
    placement={'bottom'}
    arrow>
      <span className={classes.infoIcon}>
        <InfoIcon />
      </span>
    </Tooltip>
  );
};

export default JobSearchEngineTooltip;
